// Copied from Beautiful Cookie Consent config file used on scalar.io wordpress site
// We have hidden the consent Modal (that shows immediately on page load by default)
// since that is not required by CCPA,
// instead the user can click the "Manage Cookie Preferences"

const scalarCookieConsentConfig = {
  guiOptions: {
    consentModal: {
      layout: 'bar inline',
      position: 'bottom',
      equalWeightButtons: false,
      flipButtons: true,
    },
    preferencesModal: {
      layout: 'box',
      position: 'right',
      equalWeightButtons: true,
      flipButtons: false,
    },
  },
  categories: {
    Necessary: { enabled: true, readOnly: true },
    Functionality: { enabled: true, readOnly: false },
    Analytics: { enabled: true, readOnly: false },
  },
  language: {
    default: 'en',
    autoDetect: 'browser',
    translations: {
      en: {
        consentModal: {
          title: 'Hello traveller, its cookie time!',
          description:
            'Websites and apps store and retrieve information, including cookies, which can be shared with third parties. This tool is provided to tailor choices and change consent.',
          closeIconLabel: '',
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Reject all',
          showPreferencesBtn: 'Manage preferences',
          footer:
            '<a href="https://scalar.io/privacy-policy/">Privacy Policy</a>\n<a href="https://scalar.io/terms-of-service/">Terms and conditions</a>',
        },
        preferencesModal: {
          title: 'Consent Preferences Center',
          closeIconLabel: 'Close modal',
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Reject all',
          savePreferencesBtn: 'Save preferences',
          serviceCounterLabel: 'Service|Services',
          sections: [
            {
              title: 'Cookie Usage',
              description:
                'Websites and apps store and retrieve information, including cookies, which can be shared with third parties. This tool is provided to tailor choices and change consent.',
            },
            {
              title:
                'Strictly Necessary Cookies <span class="pm__badge">Always Enabled</span>',
              description:
                'These cookies are essential for the site to function and cannot be toggled off. They assist with security, user authentication, customer support, etc.',
              linkedCategory: 'Necessary',
            },
            {
              title: 'Analytics Cookies',
              description:
                'These cookies help us understand how visitors interact with our site. They allow us to measure traffic and improve site performance.',
              linkedCategory: 'Analytics',
            },
            {
              title: 'More information',
              description:
                'Questions regarding our privacy policy on cookies and your choices, please <a class="cc__link" href="https://scalar.io/contact/">contact us</a>.',
            },
          ],
        },
      },
    },
  },
  onFirstConsent () {
    // You can add custom logic here if needed
  },
  onChange () {
    // You can add custom logic here if needed
  },
  onModalShow () {
    // You can add custom logic here if needed
  },
  cookie: {
    name: 'scalar-consent',
    expiresAfterDays: '365',
  },
};

export { scalarCookieConsentConfig };
